import React, { useEffect, useState } from "react"
import axios from "axios"
import Cookies from "js-cookie"
import { getFoodImageUrl } from "../utils/foodAvailability"

const API = "https://food-backend-9733.onrender.com"

const Orders = () => {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [openItems, setOpenItems] = useState({})
  const [openTracking, setOpenTracking] = useState({})

  const token = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )?.token

  useEffect(() => {
    if (!token) {
      setLoading(false)
      return
    }

    axios.get(`${API}/orders`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      console.log("ORDERS DATA:", res.data)
      setOrders(res.data)
      setLoading(false)
    })
    .catch(err => {
      console.log("ORDER FETCH ERROR:", err)
      setLoading(false)
    })
  }, [token])

  const steps = [
    "pending",
    "confirmed",
    "preparing",
    "out for delivery",
    "delivered"
  ]

  const getStatusIndex = (status) => {
    const index = steps.indexOf(status || "pending")
    return index === -1 ? 0 : index
  }

  const toggleOrderItems = (orderId) => {
    setOpenItems(prev => ({
      ...prev,
      [orderId]: !prev[orderId]
    }))
  }

  const toggleTracking = (orderId) => {
    setOpenTracking(prev => ({
      ...prev,
      [orderId]: !prev[orderId]
    }))
  }

  if (loading) {
    return (
      <div className="orders-page">
        <div className="orders-loading">
          Loading Orders...
        </div>
      </div>
    )
  }

  return (
    <div className="orders-page">

      <div className="orders-hero">
        <h1>My Orders</h1>
        <p>Track your homemade food orders here.</p>
      </div>

      {orders.length === 0 && (
        <div className="empty-orders-box">
          <h2>📦</h2>
          <h3>No Orders Found</h3>
          <p>Start ordering delicious homemade food.</p>
        </div>
      )}

      <div className="orders-list">
        {orders.map(order => {
          const activeIndex = getStatusIndex(order.order_status)

          return (
            <div key={order.id} className="order-card">

              <div className="order-card-top">
                <div>
                  <h2>Order #{order.id}</h2>

                  <p>
                    {order.created_at
                      ? new Date(order.created_at).toLocaleString()
                      : "No Date"}
                  </p>
                </div>

                <span
                  className={`order-status ${
                    (order.order_status || "pending")
                      .replaceAll(" ", "-")
                  }`}
                >
                  {order.order_status || "pending"}
                </span>
              </div>

              <div className="order-info-grid">
                <div>
                  <h4>Payment</h4>
                  <p>{order.payment_method || "COD"}</p>
                  <span>{order.payment_status || "pending"}</span>
                </div>

                <div>
                  <h4>Total Amount</h4>
                  <h3>₹ {order.total}</h3>
                </div>

                <div>
                  <h4>Phone</h4>
                  <p>{order.phone}</p>
                </div>
              </div>

              <div className="order-address-box">
                <h3>Delivery Address</h3>

                <p>{order.address}</p>
                <p>{order.landmark}</p>
                <p>{order.city}, {order.state}</p>
                <p>{order.country} - {order.pincode}</p>
              </div>

              <button
                type="button"
                className="order-toggle-btn"
                onClick={() => toggleOrderItems(order.id)}
              >
                <span>Order Items</span>
                <b>{openItems[order.id] ? "-" : "+"}</b>
              </button>

              {openItems[order.id] && (
                <div className="order-items-section">
                  {order.items && order.items.length > 0 ? (
                    order.items.map(item => (
                      <div
                        key={item.id}
                        className="order-item-card"
                      >
                        <img
                          src={getFoodImageUrl(item, API)}
                          alt={item.name}
                          className="order-item-img"
                          onError={(e) => {
                            e.currentTarget.src = "/logo192.png"
                          }}
                        />

                        <div className="order-item-info">
                          <h4>{item.name}</h4>

                          <p>
                            Size: {item.selected_size || "250g"}
                          </p>

                          <p>
                            Quantity: {item.quantity}
                          </p>

                          <p>
                            Price: ₹ {item.price}
                          </p>
                        </div>

                        <div className="order-item-total">
                          ₹ {Number(item.price) * Number(item.quantity)}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No items found</p>
                  )}
                </div>
              )}

              <button
                type="button"
                className="order-toggle-btn"
                onClick={() => toggleTracking(order.id)}
              >
                <span>Tracking</span>
                <b>{openTracking[order.id] ? "-" : "+"}</b>
              </button>

              {openTracking[order.id] && (
                <div className="tracking-box">
                  <div className="tracking-progress">
                    {steps.map((step, index) => (
                      <div
                        key={step}
                        className={
                          index <= activeIndex
                            ? "tracking-step active-track"
                            : "tracking-step"
                        }
                      >
                        <div className="track-circle">
                          {index <= activeIndex ? "✓" : index + 1}
                        </div>

                        {index < steps.length - 1 && (
                          <div
                            className={
                              index < activeIndex
                                ? "track-line active-line"
                                : "track-line"
                            }
                          />
                        )}

                        <p>{step}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Orders
